import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Personal from "./Personal";
import Education from "./Education";
import Experience from "./Experience";
import Project from "./Project";
import Button from "../Utils/Button";

const CVForm = ({
  cv,
  onChangePersonal,
  onChangeExperience,
  onAddExperience,
  onDeleteExperience,
  onChangeEducation,
  onAddEducation,
  onDeleteEducation,
  onChangeProject,
  onAddProject,
  onDeleteProject,
  onPrint,
  onLoadExample,
  onReset,
}) => {
  return (
    <CVFormWrapper>
      <Personal personalInfo={cv.personalInfo} onChange={onChangePersonal} />
      <Experience
        experience={cv.experience}
        onChange={onChangeExperience}
        onAdd={onAddExperience}
        onDelete={onDeleteExperience}
      />
      <Education
        education={cv.education}
        onChange={onChangeEducation}
        onAdd={onAddEducation}
        onDelete={onDeleteEducation}
      />
      <Project
        projects={cv.projects}
        onChange={onChangeProject}
        onAdd={onAddProject}
        onDelete={onDeleteProject}
      />
      <>
        <Button text="Generate PDF" onClick={onPrint} primary></Button>
        <Button text="Load Example" onClick={onLoadExample} secondary></Button>
        <Button text="Reset" onClick={onReset} red></Button>
      </>
    </CVFormWrapper>
  );
};

const CVFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 210mm;
  padding: 2rem;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.light};
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`;

export default CVForm;

CVForm.propTypes = {
  cv: PropTypes.object.isRequired,
  onChangePersonal: PropTypes.func.isRequired,
  onChangeExperience: PropTypes.func.isRequired,
  onAddExperience: PropTypes.func.isRequired,
  onDeleteExperience: PropTypes.func.isRequired,
  onChangeEducation: PropTypes.func.isRequired,
  onAddEducation: PropTypes.func.isRequired,
  onDeleteEducation: PropTypes.func.isRequired,
  onChangeProject: PropTypes.func.isRequired,
  onAddProject: PropTypes.func.isRequired,
  onDeleteProject: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  onLoadExample: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};
